// eslint-disable-next-line
export default new (class ContactUsModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.order = data.order || "";
    model.type = data.section || "";
    model.leftSection = data.leftContent || false;
    // title เป็น null ได้ — section 'email' กับ 'social' ไม่มีหัวข้อ
    model.title_en = data.title?.detail_EN || "";
    model.title_th = data.title?.detail_TH || "";
    model.content = data.content || [];

    return model;
  }
})();
